<template>
  <div>
      <div v-if="!showCustomMessage" class="modal-body-text">You are requesting to change <span class="modal-event-name">{{itemName}}</span> after it's been approved. Upon submitting, you agree:</div>
      <div v-if="!showCustomMessage">
        <ul>
          <li class="modal-body-text modal-body-text-li">To accept your request to change the event must go through approval again</li>
          <li class="modal-body-text modal-body-text-li">That we cannot guarantee your event will be approved for your requested change</li>
          <li class="modal-body-text modal-body-text-li">
            To pay the fee associated with your contract with ADURO (review for details)
          </li>
        </ul>
        <div class="modal-body-text modal-body-text-li">Continuing to the next screen to change your event will NOT charge you. Submitting your changes will.</div>
      </div>
      <div v-else v-html="customMessage" class="custom-message modal-body-text">{{customMessage}}</div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  name: 'change-order-body-modal',
  props: {
    itemName: {
      type: String
    }
  },
  computed: {
    showCustomMessage () {
      let message = this.getMessage;
      return message !== '' && message !== null;
    },
    customMessage () {
      return this.getMessage;
    },
    ...mapGetters({
      getMessage: 'GETTER_GET_CHANGE_ORDER_MESSAGE'
    })
  }
}
</script>

<style lang="less">
@import '../../styles/variables.less';
.modal-event-name{
  font-weight: 600;
  color: @blue;
}
.custom-message{
  max-height: 400px;
  // overflow-x: hidden;
  overflow-y: auto;
}
</style>




// WEBPACK FOOTER //
// ChangeOrder.vue?29085834